import Vue from 'vue';
export default {
  data() {
    return {
      searchTitle: '',
      searchModal: false,
      isSearch: false,
      tableHeader: [
        {
          text: 'نام و نام خانوادگی',
          value: 'fullName',
          align: 'center',
          isGroupable: true,
        },
        {
          text: 'شماره پرسنلی',
          value: 'personalNumber',
          align: 'center',
          isGroupable: true,
        },
        {
          text: 'تاریخ ورود',
          value: 'loginDate',
          align: 'center',
          isGroupable: true,
        },
        {
          text: 'شناسه ورود',
          value: 'logInIpAddress',
          align: 'center',
          isGroupable: true,
        },
        {
          text: 'شناسه خروج',
          value: 'logOutIpAddress',
          align: 'center',
          isGroupable: true,
        },
        {
          text: 'تاریخ خروج',
          value: 'logoutDate',
          align: 'center',
          isGroupable: true,
        },
        {
          text: 'مدت زمان',
          value: 'duration',
          align: 'center',
          isGroupable: true,
        },
      ],
      tableItems: [],
      searchFromDate: '',
      searchToDate: '',
      searchUserId: null,
      tempSearchFromDate: '',
      showSearchFromDate: false,
      tempSearchToDate: '',
      showSearchToDate: false,
    };
  },
  methods: {
    makeDataReady: function (data) {
      this.tableItems = [];
      for (let i = 0; i < data.length; i++) {
        let loginDate = '-';
        let logoutDate = '-';
        let fullName = '';
        let duration = Math.round(data[i].duration);
        duration = duration * 1000;
        if (data[i].loginDate) {
          loginDate = Vue.moment(data[i].loginDate).format('HH:mm:ss jYYYY/jM/jD');
        }
        if (data[i].logoutDate) {
          logoutDate = Vue.moment(data[i].logoutDate).format('HH:mm:ss jYYYY/jM/jD');
        }
        if (data[i].userFirstName) {
          fullName += data[i].userFirstName + ' ';
        } else {
          fullName += '-';
        }
        if (data[i].userLastName) {
          fullName += data[i].userLastName;
        } else {
          fullName += '-';
        }
        this.tableItems.push({
          fullName: fullName,
          loginDate: loginDate,
          logoutDate: logoutDate,
          logInIpAddress: data[i]?.logInIpAddress || '-',
          logOutIpAddress: data[i]?.logOutIpAddress || '-',
          personalNumber: data[i].personnelNumber ? data[i].personnelNumber : '-',
          duration: this.msToTime(duration),
        });
      }
    },
    setPreTimes: function () {
      this.tempSearchFromDate = '00:00:00 ';
      let temp = Vue.moment().format('jYYYY-jMM-jDD');
      this.tempSearchFromDate += temp;
      this.searchFromDate = Vue.moment().format('YYYY-MM-DD');
      this.searchFromDate += 'T00:00:00';
      this.searchToDate = Vue.moment().format('YYYY-MM-DDTHH:mm:ss');
      this.tempSearchToDate = Vue.moment().format('HH:mm:ss jYYYY-jMM-jDD');
    },
    dateTimeChange: function (type) {
      if (type == 'searchFromDate') {
        if (this.searchFromDate) {
          this.tempSearchFromDate = Vue.moment(this.searchFromDate).format(
            'HH:mm:ss jYYYY-jMM-jDD',
          );
        }
      } else if (type == 'searchToDate') {
        if (this.searchToDate) {
          this.tempSearchToDate = Vue.moment(this.searchToDate).format('HH:mm:ss jYYYY-jMM-jDD');
        }
      }
    },
    clearDateTime: function (type) {
      if (type == 'searchFromDate') {
        this.showSearchFromDate = false;
        this.searchFromDate = '';
        this.tempMoveFromStationTime = '';
      } else if (type == 'searchToDate') {
        this.showSearchToDate = false;
        this.searchToDate = '';
        this.tempSearchFromDate = '';
      }
    },
    showSearchModal: function () {
      this.searchModal = true;
    },
    search: function () {
      this.page = 1;
      this.searchModal = false;
      this.isSearch = true;
      this.$refs.pagination.page = 1;
      this.getQCUsersLoginLogoutReportFunction(
        this.searchFromDate,
        this.searchToDate,
        this.searchUserId,
        this.page,
        this.pageSize,
      );
    },
    removeFilters: function () {
      this.searchUserId = null;
      this.searchFromDate = '';
      this.searchToDate = '';
      this.tempSearchFromDate = '';
      this.showSearchFromDate = false;
      this.tempSearchToDate = '';
      this.showSearchToDate = false;
      this.isSearch = false;
      this.page = 1;
      this.$refs.pagination.page = 1;
      this.getQCUsersLoginLogoutReportFunction(
        this.searchFromDate,
        this.searchToDate,
        this.searchUserId,
        this.page,
        this.pageSize,
      );
    },
    cancelSearch: function () {
      this.searchUserId = null;
      this.searchFromDate = '';
      this.searchToDate = '';
      this.tempSearchFromDate = '';
      this.showSearchFromDate = false;
      this.tempSearchToDate = '';
      this.showSearchToDate = false;
      this.searchModal = false;
    },
    pad: function (n, z) {
      z = z || 2;
      return ('00' + n).slice(-z);
    },
    msToTime: function (s) {
      let ms = s % 1000;
      s = (s - ms) / 1000;
      let secs = s % 60;
      s = (s - secs) / 60;
      let mins = s % 60;
      let hrs = (s - mins) / 60;
      return this.pad(hrs) + ':' + this.pad(mins) + ':' + this.pad(secs);
    },
  },
};
